'use client';
import { useState } from 'react';
import styles from './styles.module.scss';

export interface TooltipProps {
  children?: JSX.Element | JSX.Element[] | string;
  isOpen: boolean;
  onCloseTooltip?: () => void;
}

const Tooltip = ({ children, isOpen, onCloseTooltip }: TooltipProps) => {
  const [open, setOpen] = useState(isOpen);
  if (!open) return null;

  const handleClose = (): void => {
    setOpen(false);
  };

  return (
    <span className={styles['tooltip']}>
      {children}
      <span className={styles['nub']} />
      <span className={styles['exit']} onClick={handleClose}>
        ×
      </span>
    </span>
  );
};

export default Tooltip;
